import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesome } from '../FontAwesome';
import './Paginate.scss';
import { Select } from '../Select/component';

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export class CursorPaginate extends React.PureComponent {
  static propTypes = {
    pageSize: PropTypes.number.isRequired,
    totalResults: PropTypes.number,
    hasNextPage: PropTypes.bool,
    hasPreviousPage: PropTypes.bool,
    onNextPage: PropTypes.func.isRequired,
    onPreviousPage: PropTypes.func.isRequired,
    handlePageSizeChange: PropTypes.func.isRequired,
    showPageSizeSelector: PropTypes.bool.isRequired,
    pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  };

  static defaultProps = {
    pageSizeOptions: PAGE_SIZE_OPTIONS,
    totalResults: null,
    hasNextPage: false,
    hasPreviousPage: false,
  };

  onPageSizeChange = (value) => {
    const { handlePageSizeChange } = this.props;
    if (handlePageSizeChange) {
      handlePageSizeChange(value);
    }
  };

  onPreviousClick = () => {
    const { hasPreviousPage, onPreviousPage } = this.props;
    if (hasPreviousPage) {
      onPreviousPage();
    }
  };

  onNextClick = () => {
    const { hasNextPage, onNextPage } = this.props;
    if (hasNextPage) {
      onNextPage();
    }
  };

  render() {
    const {
      hasNextPage,
      hasPreviousPage,
      pageSize,
      showPageSizeSelector,
      pageSizeOptions,
      totalResults,
    } = this.props;

    return (
      <react-paginate>
        <div className="paginate-left">
          {showPageSizeSelector && (
            <Select
              className="pageSize"
              value={pageSize}
              onValueChange={this.onPageSizeChange}
              options={pageSizeOptions.map((pageSizeOption) => ({
                value: pageSizeOption,
                label: parseInt(pageSizeOption, 10)
                  ? `${pageSizeOption} per page`
                  : 'Show All',
              }))}
            />
          )}
          {totalResults !== null && <div>Total: {totalResults}</div>}
        </div>
        <div className="paginate-right">
          <button
            type="button"
            disabled={!hasPreviousPage}
            className={classNames('previous', { disabled: !hasPreviousPage })}
            onClick={this.onPreviousClick}
          >
            <FontAwesome name="caret-left" />
            <span className="hidden-text">Show previous page</span>
          </button>
          <button
            type="button"
            disabled={!hasNextPage}
            className={classNames('next', { disabled: !hasNextPage })}
            onClick={this.onNextClick}
          >
            <FontAwesome name="caret-right" />
            <span className="hidden-text">Show next page</span>
          </button>
        </div>
      </react-paginate>
    );
  }
}
